/** Minimum sign-ups before showing conversion rate on the Sign-Ups card. */
export const MIN_SIGNUPS_FOR_CONVERSION_LINE = 10;

export const showSignUpConversionLine = (signupCount) =>
  Number(signupCount) >= MIN_SIGNUPS_FOR_CONVERSION_LINE;

/** Minimum interactive sessions before showing the session-length bar chart. */
export const MIN_INTERACTIVE_SESSIONS_FOR_DISTRIBUTION_CHART = 10;

export const showSessionDistributionChart = (sessionCount) =>
  Number(sessionCount) >= MIN_INTERACTIVE_SESSIONS_FOR_DISTRIBUTION_CHART;

/** Minimum unique visitors before showing the visitor trend line chart. */
export const MIN_UNIQUE_VISITORS_FOR_TREND_CHART = 10;

export const showUniqueVisitorsTrendChart = (visitorCount) =>
  Number(visitorCount) >= MIN_UNIQUE_VISITORS_FOR_TREND_CHART;
